import React from 'react';
import useProfileEditor from 'containers/pages/profile/hooks/useProfileEditor';
import ProfileEditorSummary from 'containers/pages/profile/components/ProfileEditorSummary';
import ProfileEditorPersonal from 'containers/pages/profile/components/ProfileEditorPersonal';
import ProfileEditorCompany from 'containers/pages/profile/components/ProfileEditorCompany';
import ProfileEditorAddresses from 'containers/pages/profile/components/ProfileEditorAddresses';
import useProfile from 'containers/pages/profile/hooks/useProfile';
import ProfileHeader from 'containers/pages/profile/components/ProfileHeader';
import ProfileSummary from 'containers/pages/profile/components/ProfileSummary';
import ProfilePersonal from 'containers/pages/profile/components/ProfilePersonal';
import ProfileAddresses from 'containers/pages/profile/components/ProfileAddresses';
import ProfileCompany from 'containers/pages/profile/components/ProfileCompany';
import LoadingBackdrop from 'components/LoadingBackdrop';
import ChangePassword from 'containers/pages/profile/components/ChangePassword';
import USER from 'containers/pages/profile/ts/profileEditorEnum';
import ProfileEditorNotes from 'containers/pages/profile/components/ProfileEditorNotes';
import ProfileEditorChangePassword from 'containers/pages/profile/components/ProfileEditorChangePassword';
import ProfileEditorBtns from 'containers/pages/profile/components/ProfileEditorBtns';

/**
 * @component Profile
 * @returns {JSX.Element}
 */
function Profile() {
	const { state, handler } = useProfile();

	const { loading, canNotSave, editorUser, valid, onHandle, onUpdate, onReset } = useProfileEditor(
		state,
		handler.onCanEdit,
		handler.onSetUser,
	);

	return (
		<>
			{state.user.id !== '' && (
				<section style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1rem' }}>
					<ProfileHeader
						canEdit={state.canEdit}
						onOpenPwd={handler.onOpenPwd}
						onCanEdit={handler.onCanEdit}
					/>
					{state.canEdit ? (
						<section style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
							<ProfileEditorSummary editorUser={editorUser} valid={valid} onHandle={onHandle} />
							<ProfileEditorPersonal
								editorUser={editorUser}
								valid={valid}
								languages={state.languages}
								contactTypes={state.contactTypes}
								roleGroups={state.roleGroups}
								userInfo={state.userInfo}
								onHandle={onHandle}
							/>
							<ProfileEditorCompany
								editorUser={editorUser}
								valid={valid}
								companies={state.companies}
								accessibleData={state.accessibleData}
								onHandle={onHandle}
							/>
							<ProfileEditorAddresses addresses={editorUser[USER.ADDRESSES]} onHandle={onHandle} />
							<ProfileEditorNotes notes={editorUser[USER.NOTES]} onHandle={onHandle} />
							<ProfileEditorChangePassword
								pwd={editorUser[USER.PASSWORD]}
								pwdValid={valid[USER.PASSWORD]}
								confirmPwd={editorUser[USER.CONFIRM_PASSWORD]}
								confirmPwdValid={valid[USER.CONFIRM_PASSWORD]}
								onHandle={onHandle}
							/>
							<ProfileEditorBtns onUpdate={onUpdate} onReset={onReset} canNotSave={canNotSave} />
						</section>
					) : (
						<section style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
							<ProfileSummary user={state.user} userInfo={state.userInfo} />
							<ProfilePersonal
								user={state.user}
								languages={state.languages}
								contactTypes={state.contactTypes}
								roleGroups={state.roleGroups}
							/>
							<ProfileCompany user={state.user} companies={state.companies} />
							<ProfileAddresses addresses={state.user.addresses} />
						</section>
					)}
				</section>
			)}
			<ChangePassword open={state.openPwd} user={state.user} onOpen={handler.onOpenPwd} />
			<LoadingBackdrop open={state.loading} />
			<LoadingBackdrop open={loading} />
		</>
	);
}

export default Profile;
